// import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import {
  KYC_DOCUMENT_TYPES,
  Passport,
  DriverLicenseOrPassport,
  DriverLicenseOrStateIssuedIDCard,
  KYC_SOCURE_DOCUMENT_TYPES,
} from '../util/constants';
import IdCardIcon from '../components/Icons/IdCardIcon';
import CheckIcon from '../components/Icons/CheckIcon';
import { PAGES } from '../constants/pages';
import { getDocumentsByApplicantType } from '../util/helpers/kycDocumentsFiltering';

const useKycProofOfIdentityDocuments = (requiredDocuments, applicantType) => {
  // const { t } = useTranslation();

  const getPath = (value) =>
    PAGES.KYC_PROOF_OF_IDENTITY[String(applicantType).toUpperCase()].UPLOAD[
      value
    ];

  const getIdentityDocuments = (documents) => {
    const documentsByApplicantType = getDocumentsByApplicantType(
      documents,
      applicantType,
    );
    return documentsByApplicantType
      .filter(
        (document) =>
          [
            Passport,
            DriverLicenseOrPassport,
            DriverLicenseOrStateIssuedIDCard,
          ].indexOf(KYC_DOCUMENT_TYPES[`${document.DocumentType}`]) > -1,
      )
      .filter(
        (document) =>
          document.Caption.includes('Front') ||
          document.Caption === 'PassportDocument',
      );
  };

  const filterIdentityDocumentsBasedOnType = (documents) =>
    documents.flatMap((document) => {
      switch (KYC_DOCUMENT_TYPES[`${document.DocumentType}`]) {
        case DriverLicenseOrPassport:
          if (
            documents.filter(
              (document) =>
                KYC_DOCUMENT_TYPES[`${document.DocumentType}`] === Passport,
            ).length
          )
            return [
              {
                ...document,
                title: i18next.t('kycVerification.driversLicense'),
                Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
                SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[1],
                path: getPath('DRIVERS_LICENSE'),
              },
            ];
          return [
            {
              ...document,
              title: i18next.t('kycVerification.driversLicense'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[1],
              path: getPath('DRIVERS_LICENSE'),
            },
            {
              ...document,
              title: i18next.t('kycVerification.passport'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[0],
              path: getPath('PASSPORT'),
            },
          ];
        case DriverLicenseOrStateIssuedIDCard:
          return [
            {
              ...document,
              title: i18next.t('kycVerification.driversLicense'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[1],
              path: getPath('DRIVERS_LICENSE'),
            },
            {
              ...document,
              title: i18next.t('kycVerification.other'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[2],
              path: getPath('GOVERNMENT_ID'),
            },
          ];
        case Passport:
          return [
            {
              ...document,
              title: i18next.t('kycVerification.passport'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[0],
              path: getPath('PASSPORT'),
            },
          ];

        default:
          return [
            {
              ...document,
              title: document.Caption,
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              SocureDocumentType: KYC_SOCURE_DOCUMENT_TYPES[0],
              path: getPath('PASSPORT'),
            },
          ];
      }
    });

  const kycIdentityOptions = () => {
    if (!requiredDocuments.length) return;

    const indentityDocuments = getIdentityDocuments(requiredDocuments);
    const documents = filterIdentityDocumentsBasedOnType(indentityDocuments);
    return documents;
  };

  return { kycIdentityOptions };
};

useKycProofOfIdentityDocuments.propTypes = {};

export default useKycProofOfIdentityDocuments;
